import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TextField, CircularProgress, Autocomplete } from '@mui/material';
import {fetchUsers} from '../../Redux/Action';
import debounce from 'lodash.debounce';

export const AutoCompleteUsers = ({field = 'employee_id', data, setData, selectedUser, filters }) => {

    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [selected, setSelected] = useState(selectedUser || null);

    // 🔁 Debounced search (debounce returns a stable fn; deps intentionally omitted)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- debounce() identity is stable
    const debouncedFetch = useCallback(
        debounce(async (searchText) => {
            setLoading(true);
            const columns = ['id', 'first_name', 'last_name', 'email'];
            await fetchUsers({dispatch, filters: { columns, keyword: searchText, paginate: false, direct: true, ...(filters || {}) }}).then((res) => {
                if (res.success) {
                    setItems(res.data);
                }
            });
            setLoading(false);
        }, 400),
        []
    );

    useEffect(() => {
        if (inputValue.length >= 3) {
            debouncedFetch(inputValue);
        } else {
            setItems([]);
        }
    }, [inputValue, debouncedFetch]);

    useEffect(() => {
        if (selectedUser && !selected) {
            setSelected(selectedUser);
        }
    }, [selectedUser, selected]);

    const handleInputChange = (event, value, reason) => {
        if (reason === 'input') {
            setInputValue(value);
        }
    };

    const handleChange = (event, newValue) => {
        setSelected(newValue);
        setData((prev) => ({
            ...prev,
            [field]: newValue?.id || null,
        }));
    };

    const getOptionLabel = (option) => {
        return [option?.first_name, option?.last_name].filter(Boolean).join(' ') || ''
    }

    return (
        <Autocomplete
            options={items}
            value={selected}
            onChange={handleChange}
            onInputChange={handleInputChange}
            getOptionLabel={(option) => getOptionLabel(option)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Select User"
                    placeholder="Type at least 3 characters"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress size={20} />}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};
